export const mapEntityByLanguage = (entityArr: Array<any>) => {
  const entityMap = new Map<string, any>();

  entityArr.forEach((entity) => {
    const exists = entityMap.get(entity.language!);

    if (!exists) {
      entityMap.set(entity.language!, entity);
    }
  });

  return entityMap;
};
